import { useTitle } from 'react-use'
import { APP_TITLE } from 'src/constants'

function useAppTitle(title: string): void {
  useTitle(`${title} | ${APP_TITLE}`)
}

export default useAppTitle
